export default __webpack_public_path__ + "static/media/ratchets-and-sockets-sizes-types-and-uses-section-1.c7916f53.webp";